
import FieldDropdown from "../dropdown/dropdown";
import FieldConfig from "../../proto/field-config";
import {GROUP_INFO} from "../../../gd/const/fields/field2-groups";
import FieldStatus_PopoverOption from "./components/popover/option";
import FieldStatus_InlineValueNotEmpty from "./components/inline-edit/value-not-empty";
import ImportFromCSVModule from "../../../gd-modules/import-from-csv/import-from-csv-module";
import FieldStatus_ConditionForm from "./render/condition";
import {ProjectSystemType} from "../../../model2/project/types"
import {EntityType} from "../../../gd/const/item";
import {SortDirection} from "../../../data-structures/sort";
import ItemModel from "../../../model2/item/item-model";

export default class FieldStatus extends FieldDropdown {

    FIELD_DEFAULT_WIDTH = 150

    constructor(config:FieldConfig) {
        super(config)

        // options and edit is not implemented for status yet

        this.typeLabel          = "Status"
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Status field"

        this.filterType         = null
        this.icon               = 'i5-statuses'

        _.assign(this.components, {
            PopoverOption           : FieldStatus_PopoverOption,
            InlineValueNotEmpty     : FieldStatus_InlineValueNotEmpty
        })

        _.assign(this.classes, {
            inlineValueClass    : ''        // used to redefine default width in InlineValueNotEmpty
        })

        _.assign(this.renderComponents,{
            conditionForm           : FieldStatus_ConditionForm
        })
    }

    normalizeToCSVValue(model: any): any {
        let res

        // check item is task or project (systemType for both of them are of numeric value)
        if (model.taskTypeId) {
            res = gd.session.statuses.get(model.statusId).name
        } else {
            switch (model.systemType){
                case ProjectSystemType.FOLDER   :
                case ProjectSystemType.PAGE     :
                case ProjectSystemType.CATEGORY :
                case ProjectSystemType.LINK     :
                case ProjectSystemType.EMBED    :
                case ProjectSystemType.BACKLOG  :
                case ProjectSystemType.TAG      :
                    res = gd.const.project.workfolderStatusList[model.systemStatus]
                    break

                case ProjectSystemType.SPRINT   :
                    res = gd.const.project.sprintStatusList[model.systemStatus]
                    break

                default                         :
                    res = gd.session.statuses.get(model.statusId).name
                    break
            }
        }
        return res
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        value = value.trim()

        // find status by name
        const allStatuses = gd.session.statuses.filterByCompany(gd.companyId).models

        const searchValue = value.toLowerCase()
        const status = _.find(allStatuses,(status=>
            !status.isDeleted && status.name.toLowerCase() === searchValue
        ))

        if (status) {
            return status.id
        } else {
            return undefined
        }
    }

    listItemSortFunctions(sort: SortDirection):any {
        const functionsArray = [
            ((listItem: ItemModel)=>{
                let result = 0

                switch (listItem.type) {
                    case EntityType.PROJECT:
                        switch (listItem.project.systemType) {
                            case ProjectSystemType.FOLDER:
                            case ProjectSystemType.BACKLOG:
                            case ProjectSystemType.SPRINT:
                            case ProjectSystemType.TAG:
                                result = listItem.project.systemStatus
                                break

                            default:
                                const status = gd.session.statuses.get(listItem.project.statusId)
                                result = status ? status.systemStatus : listItem.project.systemStatus
                                break
                        }
                        break

                    case EntityType.TASK:
                        const status = gd.session.statuses.get(listItem.task.statusId)
                        result = status ? status.systemStatus : listItem.task.systemStatus
                        break
                }

                return result;
            }),
            ((listItem: ItemModel)=>{
                let result = 0

                switch (listItem.type) {
                    case EntityType.TASK:
                        let taskType = gd.session.taskTypes.get(listItem.task.taskTypeId)
                        if (taskType) {
                            let taskTypeStatus = taskType.statuses?.getByStatusId(listItem.task.statusId)
                            if (taskTypeStatus) result = taskTypeStatus.sortPosition
                        }
                        break
                }

                return result;
            }),
            ((listItem: ItemModel)=>{
                let result = 0

                switch (listItem.type) {
                    case EntityType.PROJECT:
                        switch (listItem.project.systemType){
                            case ProjectSystemType.WORKFOLDER:
                            case ProjectSystemType.BACKLOG:
                            case ProjectSystemType.TAG:
                                result = gd.const.project.workfolderStatusList[listItem.project.systemStatus]
                                break

                            case ProjectSystemType.SPRINT:
                                result = gd.const.project.sprintStatusList[listItem.project.systemStatus]
                                break

                            default:
                                const status = gd.session.statuses.get(listItem.project.statusId)
                                result = status ? status.name.toLowerCase() : gd.const.project.workfolderStatusList[listItem.project.systemStatus]
                                break
                        }
                        break

                    case EntityType.TASK:
                        const status = gd.session.statuses.get(listItem.task.statusId)
                        result = status ? status.name.toLowerCase() : 0
                }

                return result
            }),
        ]

        const directionsArray = [sort, sort, sort]

        return {
            functions   : functionsArray,
            directions  : directionsArray
        }
    }
}